import {
    DownloadIcon as Download,
    Ellipsis2Icon as Ellipsis2,
    Pass2Icon as Pass2,
    UserIcon as User,
} from '@lokalise/louis';

import { Badge } from './styles';

const navItemIcons = {
    tasks: Pass2,
    contributors: User,
    download: Download,
    more: Ellipsis2,
};

interface NavItemContentProps {
    icon?: keyof typeof navItemIcons;
    small: boolean;
    badge?: number;
}

const NavItemContents = ({ icon, small, badge }: NavItemContentProps) => {
    if (!icon) {
        return null;
    }

    const NavItemIcon = navItemIcons[icon];

    return (
        <>
            <NavItemIcon size={small ? '20px' : '30px'} />
            {!!badge && (
                <Badge small={small} role="status" aria-label={`${badge} items requiring attention`}>
                    {badge > 9 ? '9+' : badge}
                </Badge>
            )}
        </>
    );
};

export default NavItemContents;
